// extracted by mini-css-extract-plugin
export default {"checkIcon":"InviteDirectorSuccessPage_checkIcon__4Vf1b","buttonContainer":"InviteDirectorSuccessPage_buttonContainer__g6k1B"};